<template>
  <div id="app">
    <!-- 어드민, 모바일등록 페이지가 아닐 때만 UI 표시 -->
    <template v-if="!isAdminPage && !isMobileRegister">
      <TopBanner @open-register="openRegisterPopup" />
      <MainHeader />
      <SideBarRight v-if="isHome" />
      <FloatingQuickMenu v-if="isHome" />
      <SideMenu v-if="!isHome && !isMobileV2" />
    </template>

    <main class="main-content">
      <router-view />
    </main>

    <MobileFloatingBar v-if="!isAdminPage" ref="mobileFloatingBar" />
  </div>
</template>

<script>
import MainHeader from '@/components/web/common/MainHeader.vue'
import TopBanner from '@/components/web/common/TopBanner.vue'
import SideBarRight from '@/components/web/common/SideBarRight.vue'
import SideMenu from '@/components/web/common/SideMenu.vue'
import MobileFloatingBar from '@/components/web/common/MobileFloatingBar.vue'
import FloatingQuickMenu from '@/components/web/common/FloatingQuickMenu.vue'

export default {
  name: 'App',
  components: {
    MainHeader,
    TopBanner,
    SideBarRight,
    SideMenu,
    MobileFloatingBar,
    FloatingQuickMenu
  },
  data() {
    return {
      isMobile: false
    }
  },
  computed: {
    isAdminPage() {
      return this.$route.path.startsWith('/admin')
    },
    isHome() {
      return this.$route.path === '/'
    },
    isMobileRegister() {
      return this.$route.path === '/m/register'
    },
    isMobileV2() {
      return this.$route.path === '/m/version2'
    }
  },
  mounted() {
    this.checkMobile()
    window.addEventListener('resize', this.checkMobile)
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.checkMobile)
  },
  methods: {
    checkMobile() {
      this.isMobile = window.innerWidth <= 768
    },
    openRegisterPopup() {
      const bar = this.$refs.mobileFloatingBar
      if (bar && bar.openRegister) {
        bar.openRegister()
      }
    }
  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+KR:wght@300;400;500;600;700&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;700&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Nanum+Myeongjo:wght@400;700;800&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Noto+Serif+KR:wght@400;500;600;700&display=swap');
@import url('https://cdn.jsdelivr.net/gh/fonts-archive/Paperlogy/subsets/Paperlogy-dynamic-subset.css');
@import url('https://fonts.googleapis.com/css2?family=Dancing+Script:wght@400;700&display=swap');

:root {
  /* 폰트 */
  --font-family: 'Noto Sans KR', sans-serif;
  --font-family2: 'Roboto', sans-serif;
  --font-family3: 'Nanum Myeongjo', serif;
  --font-family4: 'Noto Serif KR', serif;
  --font-paperlogy: 'Paperlogy', sans-serif;

  /* 컬러 */
  --thehue-primary: #004538;
  --thehue-primary-light: #006652;
  --thehue-primary-dark: #002e25;
  --sub-color: #f0efe2;
  --text-color: #666666;
  --white: #ffffff;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

#app {
  font-family: var(--font-family);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: var(--text-color);
}

.main-content {
  /* padding-top 제거 - 풀스크린 섹션용 */
  transition: padding-top 0.3s ease;
}

body.has-top-banner .main-content {
  padding-top: 48px;
}

@media (max-width: 768px) {
  html,
  body {
    overflow-x: hidden;
    width: 100%;
  }

  #app {
    overflow-x: hidden;
    width: 100%;
  }

  .main-content {
    overflow-x: hidden;
  }
}
</style>
